import { nativeEnum, number, object, preprocess, string } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { Offer_Engagement_Type } from '@occc/graphql';

import { withIsEnabled } from '../utils/with-is-enabled';

export const VoucherExpirationDaysSchema = number({ required_error: IS_REQUIRED }).positive(
  IS_POSITIVE,
);

export const VoucherCountSchema = number({ required_error: IS_REQUIRED })
  .int()
  .positive(IS_POSITIVE)
  .default(1);

export const VoucheredOfferSchema = object(
  {
    id: string(),
    name: string(),
    engagementType: nativeEnum(Offer_Engagement_Type).optional().nullable(),
  },
  { required_error: IS_REQUIRED },
);

const NormalizedVoucheredOfferSchema = preprocess(
  (data) => data ?? undefined,
  VoucheredOfferSchema,
);

export const AwardVouchersSchema = object({
  voucheredOffer: NormalizedVoucheredOfferSchema,
  voucherCount: VoucherCountSchema,
  voucherExpirationDays: VoucherExpirationDaysSchema.optional(),
});

const AwardVouchersWithExpirationDaysEnabledSchema = object({
  voucheredOffer: NormalizedVoucheredOfferSchema,
  voucherCount: VoucherCountSchema,
  voucherExpirationDays: VoucherExpirationDaysSchema,
});

const AwardVouchersWithExpirationDaysDisabledSchema = object({
  voucheredOffer: NormalizedVoucheredOfferSchema,
  voucherCount: VoucherCountSchema,
  voucherExpirationDays: number().optional(),
});

export const AwardVouchersWithExpirationDaysSchema = withIsEnabled(
  AwardVouchersWithExpirationDaysEnabledSchema,
  AwardVouchersWithExpirationDaysDisabledSchema,
);
